import React, { useState, useEffect, useRef, useCallback } from "react";
import { API } from "aws-amplify";
import Routes from "./Routes";
// import MuiThemeProvider from '@mui/material/styles/MuiThemeProvider';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { Auth } from "aws-amplify";
import * as AuthAPI from "./offline-auth/auth";
import { createTheme } from "@mui/material/styles";
import { Provider } from "react-redux";
import InstaSignaler from "./containers/conference/libs/InstaSignaler";
import VoiceCommandProcess from "./containers/conference/libs/VoiceCommandProcess";
import "./App.css";
import "./styles/scrollbar.css";
// import { } from "./;
// import {lang} from `./locale/lang-${JSON.parse(import.meta.env.VITE_lang)}.json`;Scroll issue in Authentication pages of inclass
import { languageObj } from "./locale/index";
import {
  LanguageContext,
  roleContext,
  LicenseContext,
  PayloadContext,
  DomainContext,
} from "./libs/context";

import { OffLineAPI } from "./offline-auth/api";
import { ToastContainer } from "react-toastify";
import { useHistory } from "react-router";
import { getDomainDeatils } from "./containers/actions/license";
// import { getMyLicense, getDomainDeatils } from "./containers/actions/license";
import FullPageLoader from "./containers/fullPageLoader";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import Amplify from "aws-amplify";
import { getLicense } from "./containers/actions/license";
import deviceInfo from "./containers/confsimulcast/conference/msoup/deviceInfo";
import BottomNavigation from "./components/common/bottomNavigation";

var _API = JSON.parse(import.meta.env.VITE_isOffline) ? OffLineAPI : API;
import axios from "axios";
import parseDomain from "parse-domain";
import { config } from "./config";
const _Auth = JSON.parse(import.meta.env.VITE_isOffline) ? AuthAPI.Auth : Auth;

const theme = createTheme({
  palette: {
    primary: { main: "#24a4c4" },
    secondary: {
      main: "#ff9200",
      contrastText: "#fff",
      dark: "#c67100",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
        },
        containedPrimary: {
          backgroundColor: "var(--primaryColor)",
          color: "#ffffff",
          "&:hover": {
            backgroundColor: "var(--primaryColor)",
          },
        },
      },
    },
    MuiPickersToolbar: {
      styleOverrides: {
        root: {
          "& .MuiTypography-root": {
            color: "#fff",
          },
          "& .Mui-selected": {
            color: "#fff",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          color: "#fff",
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: "#fff",
          },
        },
      },
    },
    MuiClock: {
      styleOverrides: {
        root: {
          "& .Mui-selected": {
            color: "#fff",
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
        },
      },
    },
  },
});

  const App = (props) => {
  const history = useHistory();
  const [language, setLanguage] = useState({
    value: languageObj["en"].locale,
    locale: "en",
  });
  const [license, setLicenses] = useState(null);
  // const [client set = useState({ logo: undefined, subDomain: '', whiteLable: false });
  const [init, setInit] = useState({
    isAuthenticated: undefined,
    isPlanManager: undefined,
    userId: null,
    userPayload: null,
  });

  // const [mounted, setMounted] = useState(false)
  const [loading, setLoading] = useState(true);

  const onVCCall = useRef(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const referrer = params.get("ref");
    if (!referrer) return;

    const ref_coc = sessionStorage.getItem("inclassreferrer");
    if (!ref_coc || ref_coc !== referrer) {
      sessionStorage.setItem("inclassreferrer", referrer);
      const coupon = params.get("coupon");
      if (coupon) sessionStorage.setItem("inclasscoupon", coupon);
    }

    const navType = performance.getEntriesByType("navigation")[0]?.type;
    if (navType !== "reload") {
      fetch(`${config.affiliate.baseUrl}/referrerclicks`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: referrer,
          productCode: config.affiliate.productCode,
        }),
      }).catch((err) => console.log("affiliate click error", err));
    }
  }, []);

  const instaSignaler = useRef(new InstaSignaler());
  const vcCommand = useRef(new VoiceCommandProcess());

  const [domainData, setdomainData] = useState({
    subDomain: "",
    logo__url: "",
    poolId: JSON.parse(import.meta.env.VITE_cognito).USER_POOL_ID,
    identityPoolId: JSON.parse(import.meta.env.VITE_cognito).IDENTITY_POOL_ID,
    appClientId: JSON.parse(import.meta.env.VITE_cognito).APP_CLIENT_ID,
    whiteLable: false,
  });
  
  //JSON.parse(import.meta.env.VITE_s3)
  //JSON.parse(import.meta.env.VITE_s3)

  const awsconfig= async () => {
    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        region: JSON.parse(import.meta.env.VITE_cognito).REGION,
        userPoolId: domainData.poolId,
        identityPoolId: domainData.identityPoolId,
        userPoolWebClientId: domainData.appClientId,
      },
      Storage: {
        region: JSON.parse(import.meta.env.VITE_s3).REGION,
        bucket: JSON.parse(import.meta.env.VITE_s3).PROFILEBUCKET,
        identityPoolId: domainData.identityPoolId,
      },
      API: {
        endpoints: [
          {
            name: "insta",
            endpoint: JSON.parse(import.meta.env.VITE_apiGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiGateway).REGION,
          },
          {
            name: "domain",
            endpoint: JSON.parse(import.meta.env.VITE_apiDomainGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiDomainGateway).REGION,
          },
          {
            name: "mcu",
            endpoint: JSON.parse(import.meta.env.VITE_apiMcuGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiMcuGateway).REGION,
          },
          {
            name: "user",
            endpoint: JSON.parse(import.meta.env.VITE_apiUserGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiUserGateway).REGION,
          },
          {
            name: "plan",
            endpoint: JSON.parse(import.meta.env.VITE_apiPlanGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiPlanGateway).REGION,
          },
          {
            name: "coupon",
            endpoint: JSON.parse(import.meta.env.VITE_apiCouponGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiCouponGateway).REGION,
          },
          {
            name: "transaction",
            endpoint: JSON.parse(import.meta.env.VITE_apiTransactionGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiTransactionGateway).REGION,
          },
          {
            name: "referral",
            endpoint: JSON.parse(import.meta.env.VITE_apiReferralGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiReferralGateway).REGION,
          },
          {
            name: "recording",
            endpoint: JSON.parse(import.meta.env.VITE_apiRecordingGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiRecordingGateway).REGION,
          },
          {
            name: "mcu_recording",
            endpoint: JSON.parse(import.meta.env.VITE_apimcuRecordingGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apimcuRecordingGateway).REGION,
          },
          {
            name: "content",
            endpoint: JSON.parse(import.meta.env.VITE_apiContentGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiContentGateway).REGION,
          },
          {
            name: "schedule",
            endpoint: JSON.parse(import.meta.env.VITE_apiScheduleGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiScheduleGateway).REGION,
          },
          {
            name: "address",
            endpoint: JSON.parse(import.meta.env.VITE_apiAddressGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiAddressGateway).REGION,
          },
          {
            name: "multipart_upload",
            endpoint: JSON.parse(import.meta.env.VITE_apiMultipartUploadGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiMultipartUploadGateway).REGION,
          },
          {
            name: "meetings",
            endpoint: JSON.parse(import.meta.env.VITE_apiMeetingGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiMeetingGateway).REGION,
          },
          {
            name: "mail",
            endpoint: JSON.parse(import.meta.env.VITE_apiMailGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiMailGateway).REGION,
          },
          {
            name: "broadcast",
            endpoint: JSON.parse(import.meta.env.VITE_apiBroadcastGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiBroadcastGateway).REGION,
          },
          {
            name: "test",
            endpoint: JSON.parse(import.meta.env.VITE_apiTestGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiTestGateway).REGION,
          },
          {
            name: "doc_share",
            endpoint: JSON.parse(import.meta.env.VITE_apiDocumentShareGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiDocumentShareGateway).REGION,
          },
          {
            name: "chat",
            endpoint: JSON.parse(import.meta.env.VITE_apiChatGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiChatGateway).REGION,
          },
          {
            name: "admin",
            endpoint: JSON.parse(import.meta.env.VITE_apiAdminGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiAdminGateway).REGION,
          },
          {
            name: "inVCSchedule",
            endpoint: JSON.parse(import.meta.env.VITE_invcScheduleAPI).URL,
            region: JSON.parse(import.meta.env.VITE_invcScheduleAPI).REGION,
          },
          {
            name: "inVCEmail",
            endpoint: JSON.parse(import.meta.env.VITE_invcEmailAPI).URL,
            region: JSON.parse(import.meta.env.VITE_invcEmailAPI).REGION,
          },
          {
            name: "inVCLicense",
            endpoint: JSON.parse(import.meta.env.VITE_invcLicenseAPI).URL,
            region: JSON.parse(import.meta.env.VITE_invcLicenseAPI).REGION,
          },
          {
            name: "class",
            endpoint: JSON.parse(import.meta.env.VITE_apiClassCreateGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiClassCreateGateway).REGION,
          },
          ...(import.meta.env.VITE_apiBranchGateway ? [{
            name: "branch",
            endpoint: JSON.parse(import.meta.env.VITE_apiBranchGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiBranchGateway).REGION,
          }] : []),
          {
            name: "inclassChat",
            endpoint: JSON.parse(import.meta.env.VITE_inclassChatAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inclassChatAPI).REGION,
          },
          {
            name: "inClassMcu",
            endpoint: JSON.parse(import.meta.env.VITE_inclassMcuAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inclassMcuAPI).REGION,
          },
          {
            name: "inClassReports",
            endpoint: JSON.parse(import.meta.env.VITE_inclassReportsAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inclassReportsAPI).REGION,
          },
          {
            name: "inClassAssessments",
            endpoint: JSON.parse(import.meta.env.VITE_inclassAssessmentsAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inclassAssessmentsAPI).REGION,
          },
          {
            name: "inaffiliateUser",
            endpoint: JSON.parse(import.meta.env.VITE_inaffiliateUserAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inaffiliateUserAPI).REGION,
          },
        ],
      },
    });
    try {
      const mySession = await _Auth.currentSession();
      await userHasAuthenticated(true, mySession);
    } catch (e) {
      console.log("error in app did mount === ", e);
      await userHasAuthenticated(false, null);
      if (e !== "No current user" && !JSON.parse(import.meta.env.VITE_isOfflineMCU)) {
        // alert(e);
        console.log("error in userHasAuthenticated======", e);
      }
    }
  };
  // const location = useLocation();
  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "visible" && !location.pathname.includes("/inconf/")) {
  //       window.location.reload();
  //     }
  //   };
  //   document.addEventListener("visibilitychange", handleVisibilityChange);
  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, []);

  useEffect(() => {
    const _subDomain = parseDomain(window.location.hostname);

    // ✅ Configure Amplify with default values FIRST (before getDomain API call)
    // This ensures API calls in getDomain() will work
    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        region: JSON.parse(import.meta.env.VITE_cognito).REGION,
        userPoolId: JSON.parse(import.meta.env.VITE_cognito).USER_POOL_ID,
        identityPoolId: JSON.parse(import.meta.env.VITE_cognito).IDENTITY_POOL_ID,
        userPoolWebClientId: JSON.parse(import.meta.env.VITE_cognito).APP_CLIENT_ID,
      },
      Storage: {
        region: JSON.parse(import.meta.env.VITE_s3).REGION,
        bucket: JSON.parse(import.meta.env.VITE_s3).PROFILEBUCKET,
        identityPoolId: JSON.parse(import.meta.env.VITE_cognito).IDENTITY_POOL_ID,
      },
      API: {
        endpoints: [
          {
            name: "user",
            endpoint: JSON.parse(import.meta.env.VITE_apiUserGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiUserGateway).REGION,
          },
          // Add other endpoints as needed for getDomainDeatils
          {
            name: "domain",
            endpoint: JSON.parse(import.meta.env.VITE_apiDomainGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiDomainGateway).REGION,
          },
        ],
      },
    });

    // console.log("index ==== ", JSON.parse(import.meta.env.VITE_defaultSubdomain).indexOf(_subDomain.subdomain));
    // if (window.location.hostname !== 'localhost' && window.location.hostname !== 'rp.invc.in' && _subDomain && JSON.parse(import.meta.env.VITE_defaultSubdomain).indexOf(_subDomain.subdomain) <= -1) {
    if (
     (window.location.hostname !== "localhost" &&
      _subDomain &&
      JSON.parse(import.meta.env.VITE_defaultSubdomain).indexOf(_subDomain.subdomain) <= -1) || (localStorage.getItem('subDomain') && deviceInfo().platform === 'mobile')
    ) {
      getDomain();
    } else {
      setdomainData({
        subDomain: "app",
        logo__url: "/images/logos/inclass-new.png",
        poolId: JSON.parse(import.meta.env.VITE_cognito).USER_POOL_ID,
        identityPoolId: JSON.parse(import.meta.env.VITE_cognito).IDENTITY_POOL_ID,
        appClientId: JSON.parse(import.meta.env.VITE_cognito).APP_CLIENT_ID,
        whiteLable: false,
      });
    }
  }, []);

  // useEffect(() => {
  //   if (location && location.search) {
  //     const query_data = queryString.parse(location.search);
  //     if (query_data && query_data.ref && query_data.ref !== "") {
  //       window.Cookies.set("referrer", query_data.ref);
  //     }
  //   }
  // }, [location]);

  // Rendering Problem is here

  // useEffect(() => {
  //   if (domainData) {
  //     awsconfig();
  //   }
  // }, [domainData]);

  useEffect(() => {
    // Wait for domainData to be loaded before checking authentication
    if (!domainData || !domainData.poolId) {
      console.log("Waiting for domainData to be loaded before authentication check...");
      return; // Exit early until domainData is ready
    }

    const initializeApp = async () => {
      // ✅ STEP 1: Configure AWS Amplify with domain-specific data
      await awsconfig();
      
      // ✅ STEP 2: Small delay to ensure Amplify is fully initialized internally
      await new Promise(resolve => setTimeout(resolve, 100));

      // ✅ STEP 3: Setup language
      let lang = localStorage.getItem("setLang") || "en";
      // setMounted(true);
      setLanguage({
        value:
          languageObj[lang] && languageObj[lang].locale
            ? languageObj[lang].locale
            : languageObj["en"].locale,
        locale: lang,
      });
      setLoading(true);
      
      // ✅ STEP 4: NOW check authentication (Amplify is fully configured and ready)
      if (JSON.parse(import.meta.env.VITE_isOfflineMCU)) {
        await userHasAuthenticated(false, null);
      }
      try {
        const mySession = await _Auth.currentSession();
        await userHasAuthenticated(true, mySession);
      } catch (e) {
        console.log("error in app did mount === ", e);
        // await userHasAuthenticated(false, null);
        if (e !== "No current user" && !JSON.parse(import.meta.env.VITE_isOfflineMCU)) {
          // alert(e);
          console.log("error in userHasAuthenticated======", e);
        }
      }finally{
        setLoading(false);
      }
    };
    initializeApp();
  }, [domainData]); // ✅ Added dependency on domainData

  // useEffect(() => {
  //   const pathName = window.location.pathname;
  //   if (
  //     init &&
  //     init.userPayload &&
  //     init.userPayload.role === "Admin" &&
  //     init.userPayload.licenseStatus === "Expired" &&
  //     license !== null &&
  //     license.length <= 0 &&
  // !pathName.includes("/place-your-order")
  //   ) {
  //     let qty =
  //       init.userPayload && init.userPayload.licenseCount
  //         ? init.userPayload.licenseCount
  //         : 20;
  //     history.push(`/place-your-order/INCLASSCCP/${qty}`);
  //   }
  // }, [init.userPayload, license]);

  const getUserPayload = async () => {
    setLoading(true);
    await API.get("user", `/user`)
      .then((res) => {
        if (res.status) {
          if(res?.data?.status ==='blocked'){
            const signOut = async () =>{
              await _Auth.signOut();
            }
            signOut();
            setInit({
              isAuthenticated: false,
              userId: null,
              userPayload: null,
            });
            history.push("/userblocked");
          }else{          
          //   console.log("--------------------------", res);
          //   if (res.data?.role === "Admin" && res.data?.isFree) {
          //     history.push(`/place-your-order/INCLASSFREE/30`);
          //   } else if (
          //     res.data?.role === "Admin" &&
          //     res.data?.isFree === undefined &&
          //     res?.data?.expiryAt === undefined
          //   ) {
          //     if (this.props.location.search) {
          //       history.push(`/${this.props.location.search}`);
          //     } else {
          //       history.push("/place-your-order/INCLASSCCP/30");
          //     }
          //   } else if (
          //     res.data?.role === "Admin" &&
          //     res.data?.expiryAt < new Date().valueOf()
          //   ) {
          //     // history.push("/dashboard");
          //     history.push("/licenses-expired");
          //   } else if (
          //     (res.data?.role === "student" || res.data?.role === "teacher") &&
          //     res.data?.licenseStatus === "Expired"
          //   ) {
          //     history.push("/licenses-expired");
          //     // history.push("/dashboard");
          //   } else {
          //     history.push("/dashboard");
          //   }

          // if (res.licenseStatus === "Expired" && res.data?.role === "Admin") {
          //   const qty = res?.data?.licenseCount ? res?.data?.licenseCount : 5;
          //   history.push(`/place-your-order/INCLASSCCP/${qty}`);
          // } else if (res.licenseStatus === "Expired") {
          //   // history.push("/licenses-expired");
          // }

            setInit({
              isAuthenticated: true,
              userId: res.data._id,
              userPayload: res.data,
            });
          }
        } else {
          setInit({
            isAuthenticated: false,
            userId: null,
            userPayload: null,
          });
        }
      })
      .catch((err) => {
        setInit({
          isAuthenticated: false,
          userId: null,
          userPayload: null,
        });
      });
      setLoading(false);
  };
  // const getLicense = (email) => {
  //   // console.log("email in getlicense ======", email);
  //   setLoading(true);
  //   getMyLicense(email).then((res) => {
  //     setLicenses([...res]);
  //     setLoading(false);
  //   });
  // };

  const userHasAuthenticated = useCallback(
    async (authenticated, session = null) => {
      setLoading(true);
      try {
        const payLoad = await _Auth.currentUserInfo();
        console.log("payLoad*outside if else catch*", payLoad);
        if (authenticated && payLoad && payLoad.attributes) {
          console.log("payLoad*inside if*", payLoad);
          console.log("authenticated", authenticated);
          console.log("session", session);
          // getLicense(payLoad.attributes.email);
          getUserPayload();
        } else {
          console.log("payLoad*inside else*", payLoad);
          console.log("authenticated", authenticated);
          console.log("session", session);
          localStorage.removeItem("role");
          localStorage.removeItem("userId");
          setInit({
            isAuthenticated: false,
            userId: null,
            userPayload: null,
          });
        }
      } catch (error) {
        console.log("payLoad*inside catch*", payLoad);
        console.log("authenticated", authenticated);
        console.log("session", session);
        console.log("error === ", error);
        localStorage.removeItem("role");
        localStorage.removeItem("userId");
        setInit({
          isAuthenticated: false,
          userId: null,
          userPayload: null,
        });
      }
      setLoading(false);
    },
    []
  );

  const isVCCall = (status) => {
    onVCCall.current = status;
  };

  const VCCallStatus = () => {
    return onVCCall.current;
  };

  const updateLanguage = (lang) => {
    let _lang = localStorage.getItem("setLang");
    if (_lang !== lang) {
      localStorage.setItem("setLang", lang);
      setLanguage({
        value:
          languageObj[lang] && languageObj[lang].locale
            ? languageObj[lang].locale
            : languageObj["en"].locale,
        setLang: lang,
      });
    }
  };

  const getDomain = () => {
    let subDomainValue;
    console.log("🔍 [getDomain] Starting domain detection...");
    console.log("🔍 [getDomain] window.location.hostname:", window.location.hostname);
    
    const _subDomain = parseDomain(window.location.hostname);
    subDomainValue = _subDomain?.subdomain;
    
    if((localStorage.getItem('subDomain') && deviceInfo().platform === 'mobile')){
      subDomainValue = localStorage.getItem('subDomain');
      console.log("🔍 [getDomain] Using mobile subdomain from localStorage:", subDomainValue);
    }
    
    console.log("🔍 [getDomain] Parsed subdomain:", subDomainValue);
    console.log("🔍 [getDomain] localStorage subdomain:", localStorage.getItem('subDomain'));
    console.log("🔍 [getDomain] Device platform:", deviceInfo().platform);
    
    if (subDomainValue) {
      console.log("✅ [getDomain] Subdomain found, fetching domain details for:", subDomainValue);
      setLoading(true);
      
      getDomainDeatils(subDomainValue)
        .then((res) => {
          console.log("✅ [getDomain] API response received:", res);
          
          if (res && res.data) {
            console.log("✅ [getDomain] Domain data:", res.data);
            setdomainData((prevState) => ({
              ...prevState,
              subDomain: res.data?.subdomain,
              logo__url: res.data?.logo_url?.path
                ? res.data.logo_url.path
                : "/images/logos/inclass-new.png",
              poolId: res.data?.poolId
                ? res.data.poolId
                : JSON.parse(import.meta.env.VITE_cognito).USER_POOL_ID,
              identityPoolId: res.data?.identityId
                ? res.data.identityId
                : JSON.parse(import.meta.env.VITE_cognito).IDENTITY_POOL_ID,
              appClientId: res.data?.appClientId
                ? res.data.appClientId
                : JSON.parse(import.meta.env.VITE_cognito).APP_CLIENT_ID,
              whiteLable: false,
            }));
            console.log("✅ [getDomain] Domain data set successfully");
            setLoading(false);
          } else {
            console.error("❌ [getDomain] No data in response:", res);
            window.location.href = "https://app.inclass.vc/sitenotreached";
            setLoading(false);
          }
        })
        .catch((err) => {
          console.error("❌ [getDomain] API call failed!");
          console.error("❌ [getDomain] Error details:", err);
          console.error("❌ [getDomain] Error message:", err?.message);
          console.error("❌ [getDomain] Error response:", err?.response);
          console.error("❌ [getDomain] Error status:", err?.response?.status);
          console.error("❌ [getDomain] Subdomain that failed:", subDomainValue);
          console.error("❌ [getDomain] Is Amplify configured?", typeof API !== 'undefined');
          
          // Check if it's a configuration issue
          if (err?.message?.includes('amplify') || err?.message?.includes('configure')) {
            console.error("❌ [getDomain] This appears to be an Amplify configuration issue!");
          }
          
          window.location.href = "https://app.inclass.vc/sitenotreached";
          setLoading(false);
        });
    } else {
      console.warn("⚠️ [getDomain] No subdomain found, using default configuration");
    }
  };

  const location = useLocation();

  const childProps = {
    isAuthenticated: init.isAuthenticated,
    USD: undefined,
    isAffiliate: false,
    isPlanManager: false,
    userHasAuthenticated: userHasAuthenticated,
    instaSignaler: instaSignaler.current,
    vcCommand: vcCommand.current,
    isVCCall: isVCCall,
    VCCallStatus: VCCallStatus,
    userId: init.userId,
    onP2PCall: false,
    webLogo: domainData.logo__url,
    whiteLable: domainData.whiteLable,
    language: language.value,
    setLanguage: updateLanguage,
    setLang: language.locale || "en",
    subDomain: domainData.subDomain,
  };
console.log("domainData", domainData);
  return (
    <Provider store={props.store}>
      <StyledEngineProvider injectFirst>
        <MuiThemeProvider theme={theme}>
          <LanguageContext.Provider
            value={language.value}
            locale={language.locale}
          >
            <PayloadContext.Provider
              value={{
                payload: init.userPayload,
                userId: init.userId,
                setUserPayload: getUserPayload,
                setLanguage:updateLanguage,
              }}
            >
              <DomainContext.Provider
                value={{
                  domain: domainData,
                  setDomain: getDomain                
                }}
              >
                <roleContext.Provider
                  value={
                    init && init.userPayload && init.userPayload.role
                      ? init.userPayload.role
                      : null
                  }
                >
                  <LicenseContext.Provider
                    value={{
                      license: license,
                      setLicenses: setLicenses,
                    }}
                  >
                    <div className={location.pathname === "/login" || location.pathname === "/" ? "" : "app"}>
                      {/* Wait for authentication check to complete before rendering routes */}
                      {init.isAuthenticated !== undefined && (
                        <Routes childProps={childProps} />
                      )}
                    </div>
                    <ToastContainer
                      position="top-right"
                      autoClose={3000}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnVisibilityChange
                      draggable
                      pauseOnHover
                    />
                    {loading && <FullPageLoader />}
                  </LicenseContext.Provider>
                </roleContext.Provider>
              </DomainContext.Provider>
            </PayloadContext.Provider>
          </LanguageContext.Provider>
        </MuiThemeProvider>
      </StyledEngineProvider>
    </Provider>
  );
};
export default App;
